import Prioridade from "./Prioridade";

export default class PrioridadeItem {
  constructor(id, codigo, nome, quantidade, atendido, data) {
    this.id = id;
    this.codigo = codigo;
    this.nome = nome;
    this.quantidade = quantidade;
    this.atendido = atendido;
    this.data = data;
    this.prioridade = new Prioridade(0, "", "", "", new Date(), "aberto");
  }

  update(item) {
    this.id = item.id;
    this.codigo = item.codigo;
    this.nome = item.nome;
    this.quantidade = item.quantidade;
    this.atendido = item.atendido;
    this.data = item.data;
    this.prioridade = item.prioridade;
  }
}